
export default function ProductCTA() {
  return (
    <section className="bg-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-4">
            Need More Details or a Customized Quote?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Contact our fire safety experts today for professional consultation and competitive pricing on all fire protection equipment.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Request a Quote
            </a>
            <a
              href="tel:+97455544093"
              className="border border-white hover:bg-white hover:text-gray-900 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Call Now: +974 5554 4093
            </a>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-gray-400 text-sm">
              Professional installation, maintenance, and 24/7 support services available across Qatar
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
